export default {baseURL: "https://login-api.deliver.ru/api/v1"}
